import { VersionView } from './VersionView';
import { VersionGame } from '@Models';

export class VersionGameView {
  label: string;
  game: VersionGame;
  options: Array<VersionView>;

  constructor(params: VersionGameViewParams) {
    this.label = params.label;
    this.game = params.game;
    this.options = params.options;
  }
}

export type VersionGameViewParams = {
  label: string;
  game: VersionGame;
  options: Array<VersionView>;
};
